import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "registration-content__header" }

import { ref, computed } from "vue";
import InfoText from "@/account/components/shared/info-text.vue";
import RegistrationStepsPanel from "@/account/components/registration/registration-steps-panel.vue";
import RegistrationPersonal from "@/account/components/registration/registration-personal.vue";
import PinInput from "@/account/components/inputs/pin-input.vue";
import NewPasswordInput from "@/account/components/inputs/new-password-input.vue";
import RegistrationFooter from "@/account/components/registration/registration-footer.vue";
import useAuthentication from "@/account/composables/use-authentication";
import useAuthenticationData, { authenticationErrors, authenticationData } from "@/account/composables/use-authentication-data";
import TransitionSlide from "@sazka/design-system/src/transitions/transition-slide.vue";
import { TransitionSlideDirection } from "@sazka/design-system/src/transitions/transition-slide-direction";
import useAuthenticationFlows, { authenticationStep } from "../../composables/use-authentication-flows";
import { dataLayerRegistrationError } from "@/data-layer/services/actions";


export default /*@__PURE__*/_defineComponent({
  __name: 'registration-content',
  setup(__props) {

const { sendPinProcess, nextAuthenticationStep } = useAuthentication();
const { clearAuthenticationErrors } = useAuthenticationData();
const { openLoginModal } = useAuthenticationFlows();
const registrationDataComponentRef = ref(null);
const pinInputRef = ref(null);
const newPasswordInputRef = ref(null);
const transitionDirection = ref<TransitionSlideDirection>("rtl");

const nextStepInternal = () => {
    clearAuthenticationErrors();

    if (
        (authenticationStep.value == "RegPersonal" && !registrationDataComponentRef.value.checkIfIsValid()) ||
        ((authenticationStep.value == "RegVerPhone" || authenticationStep.value == "RegPinLog") && !pinInputRef.value.checkIfIsValid()) ||
        (authenticationStep.value == "RegNewPass" && !newPasswordInputRef.value.checkIfIsValid())
    ) {
        return;
    }

    nextAuthenticationStep();
};

const resendPin = async () => {
    authenticationErrors.pinErrorMessage = "";
    await sendPinProcess(true);
    pinInputRef.value.pinResended(!authenticationErrors.pinErrorMessage);
};

const modalTitle = computed(() => {
    switch (authenticationStep.value) {
        case "RegPersonal":
        case "RegVerPhone":
        case "RegPinLog":
            return "Registrace do Sazka Klubu";
        case "RegPinOk":
            return "Vaše telefonní číslo bylo úspěšně ověřeno.";
        case "RegNewPass":
            return "Už jsme skoro tam!";
        default:
            return "";
    }
});

const modalPerex = computed(() => {
    switch (authenticationStep.value) {
        case "RegPersonal":
        case "RegVerPhone":
        case "RegPinLog":
            return "Abychom s vámi mohli roztočit Kolo štěstí, potřebujeme vědět, komu vyplatíme odměnu. Nebojte, vytvoření účtu vám zabere pár minut.";
        case "RegNewPass":
            return "Abychom Vás mohli přihlásit k Vašemu Sazka Klub účtu, musíte si vytvořit heslo.";
        default:
            return "";
    }
});

const classForCurrentState = computed(() => {
    switch (authenticationStep.value) {
        case "RegPersonal":
            return "registration-content--personal";
        case "RegNewPass":
            return "registration-content--new-pass";
        case "RegVerPhone":
        case "RegPinLog":
            return "registration-content--pin";
        default:
            return "";
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TransitionSlide, { direction: transitionDirection.value }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["registration-content", classForCurrentState.value]),
        key: _unref(authenticationStep)
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(InfoText, {
            title: modalTitle.value,
            perex: modalPerex.value,
            showBackLink: _unref(authenticationStep) == 'LoginPass',
            class: "registration-content__info-text"
          }, null, 8, ["title", "perex", "showBackLink"]),
          _withDirectives(_createVNode(RegistrationStepsPanel, { class: "registration-content__pannel" }, null, 512), [
            [_vShow, _unref(authenticationStep) == 'RegPersonal' || _unref(authenticationStep) == 'RegVerPhone' || _unref(authenticationStep) == 'RegPinLog']
          ])
        ]),
        _withDirectives(_createVNode(RegistrationPersonal, {
          ref_key: "registrationDataComponentRef",
          ref: registrationDataComponentRef,
          class: "registration-content__data"
        }, null, 512), [
          [_vShow, _unref(authenticationStep) == 'RegPersonal']
        ]),
        _withDirectives(_createVNode(PinInput, {
          ref_key: "pinInputRef",
          ref: pinInputRef,
          class: "registration-content__pin",
          modelValue: _unref(authenticationData).pin,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(authenticationData).pin) = $event)),
          name: "sms_code",
          "phone-number": _unref(authenticationData).userName,
          "error-message": _unref(authenticationErrors).pinErrorMessage,
          "onUpdate:errorMessage": _cache[1] || (_cache[1] = ($event: any) => ((_unref(authenticationErrors).pinErrorMessage) = $event)),
          onResendPin: resendPin,
          onInputErrorDetected: _unref(dataLayerRegistrationError)
        }, null, 8, ["modelValue", "phone-number", "error-message", "onInputErrorDetected"]), [
          [_vShow, _unref(authenticationStep) == 'RegVerPhone' || _unref(authenticationStep) == 'RegPinLog']
        ]),
        _withDirectives(_createVNode(NewPasswordInput, {
          ref_key: "newPasswordInputRef",
          ref: newPasswordInputRef,
          class: "registration-content__new-pass",
          modelValue: _unref(authenticationData).password,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(authenticationData).password) = $event)),
          name: "password",
          "error-message": _unref(authenticationErrors).newPasswordErrorMessage,
          "onUpdate:errorMessage": _cache[3] || (_cache[3] = ($event: any) => ((_unref(authenticationErrors).newPasswordErrorMessage) = $event)),
          onInputErrorDetected: _unref(dataLayerRegistrationError)
        }, null, 8, ["modelValue", "error-message", "onInputErrorDetected"]), [
          [_vShow, _unref(authenticationStep) == 'RegNewPass']
        ]),
        _createVNode(RegistrationFooter, {
          "authentication-step": _unref(authenticationStep),
          class: "registration-content__footer",
          onNextStep: nextStepInternal,
          onOpenLoginModal: _unref(openLoginModal)
        }, null, 8, ["authentication-step", "onOpenLoginModal"])
      ], 2))
    ]),
    _: 1
  }, 8, ["direction"]))
}
}

})